import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const MobiliansResultMob = () => {
  return <CommonResult />;
};

export default MobiliansResultMob;
